import React, {Component} from "react";
import {BrowserRouter as ReactBrowserRouter} from "react-router-dom";
import BaseComponent from "../BaseComponent";

export default class BrowserRouter extends BaseComponent {

    render() {
        return (
            <ReactBrowserRouter basename={this.getRouterBaseName()}>
                {this.props.children}
            </ReactBrowserRouter>
        );
    }
}
